import { useEffect } from "react";
import SmoothScroll from "@/components/marketing/SmoothScroll";
import Nav from "@/components/marketing/Nav";
import Hero from "@/components/marketing/Hero";
import LogoMarquee from "@/components/marketing/LogoMarquee";
import Manifesto from "@/components/marketing/Manifesto";
import HowItWorks from "@/components/marketing/HowItWorks";
import RevenueCalculator from "@/components/marketing/RevenueCalculator";
import EditorialMarquee from "@/components/marketing/EditorialMarquee";
import Proof from "@/components/marketing/Proof";
import AIWithoutOverwhelm from "@/components/marketing/AIWithoutOverwhelm";
import Pricing from "@/components/marketing/Pricing";
import FAQ from "@/components/marketing/FAQ";
import FinalCTA from "@/components/marketing/FinalCTA";
import Footer from "@/components/marketing/Footer";
import StickyCTA from "@/components/marketing/StickyCTA";
import { DialogsProvider } from "@/components/marketing/DialogsContext";

export default function Landing() {
  useEffect(() => {
    document.title =
      "PipelineForge — No Results, No Pay. Revenue Hiding in Your Database.";
  }, []);

  return (
    <DialogsProvider>
      <SmoothScroll>
        <main data-testid="landing-root" className="relative min-h-screen bg-[#050505] text-white overflow-x-hidden">
          <Nav />
          <Hero />
          <LogoMarquee />
          <Manifesto />
          <HowItWorks />
          <RevenueCalculator />
          <EditorialMarquee />
          <Proof />
          <AIWithoutOverwhelm />
          <Pricing />
          <FAQ />
          <FinalCTA />
          <Footer />
          <StickyCTA />
        </main>
      </SmoothScroll>
    </DialogsProvider>
  );
}
